import React from 'react';
import { loadTossPayments } from '@tosspayments/payment-sdk';
import _uniqueId from 'lodash/uniqueId';

const clientKey = 'test_ck_dP9BRQmyarYe7y1nYyZrJ07KzLNk';

export default function PaymentTest() {

  const handleClick = async () => {
    let timestamp = (new Date()).getTime()
    const tossPayments = await loadTossPayments(clientKey);
    console.log(tossPayments.requestPayment('CARD', {
      successUrl: 'https://qa.motiners.com/test/payment',
      paymentKey: `payment-key-${timestamp}`,
      orderId:`order-id-${timestamp}`,
      orderName: '테스트',
      customerName: '모티너스',
      amount: 1,
      failUrl: 'https://qa.motiners.com'
    }));
  }

  return (
    <button onClick={handleClick}>asd</button>
  )
}